module.exports = __webpack_public_path__ + "59de0df893c44d1824a1ce1c738e6f0e.svg";